export const SUPPORTED_UI_LANGS = Object.freeze([
    "lv",
    "en",
    "ru",
    "ee",
    "lt",
    "fi",
    "no",
    "se"
]);

export const INDEXABLE_SEO_LANGS = Object.freeze(["lv", "en", "ru"]);

export const METADATA_FALLBACK_LANG = "lv";

export const DOMAIN_LOCALE_MAP = Object.freeze({
    lv: "lv",
    ee: "ee",
    lt: "lt",
    fi: "fi",
    no: "no",
    se: "se"
});

const getSupportedLanguage = (language) => {
    if (typeof language !== "string") return null;

    const normalized = language.trim().toLowerCase().split("-")[0];

    return SUPPORTED_UI_LANGS.includes(normalized) ? normalized : null;
};

export const normalizeLanguage = (language) =>
    getSupportedLanguage(language) || METADATA_FALLBACK_LANG;

export const getLocaleFromDomain = (hostname = "") => {
    const tld = hostname.split(".").pop().toLowerCase();

    return DOMAIN_LOCALE_MAP[tld] || null;
};

export const getLanguageFromSearch = (search = "") => {
    const language = new URLSearchParams(search).get("lang");

    return getSupportedLanguage(language);
};

export const resolveLanguage = ({
    search = "",
    hostname = "",
    cookieLanguage = ""
} = {}) => {
    const explicitLanguage = getLanguageFromSearch(search);

    if (explicitLanguage) {
        return { language: explicitLanguage, source: "query" };
    }

    const domainLanguage = getLocaleFromDomain(hostname);

    if (domainLanguage) {
        return { language: domainLanguage, source: "domain" };
    }

    const fallbackLanguage = getSupportedLanguage(cookieLanguage);

    if (fallbackLanguage) {
        return { language: fallbackLanguage, source: "cookie" };
    }

    return { language: METADATA_FALLBACK_LANG, source: "default" };
};

export const withLanguageQuery = (search, language) => {
    const searchParams = new URLSearchParams(search);
    const normalizedLanguage = normalizeLanguage(language);

    searchParams.set("lang", normalizedLanguage);

    return `?${searchParams.toString()}`;
};

export const getRobotsDirective = (language) =>
    INDEXABLE_SEO_LANGS.includes(normalizeLanguage(language))
        ? "index,follow"
        : "noindex,follow";

export { getSupportedLanguage };